module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOTAiIGhlaWdodD0iNTIiIHZpZXdCb3g9IjAgMCA5MCA1MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTY0IDE3Ljg1MjRWMTQuMjE2N1YxNC4yMTMzTDQyLjA2OTYgMjQuODU1NEwyMC4wMDcgMTRWMTcuNzczM0wzOC4yMTEgMjYuNzNMMjAgMzUuNTY2NEwyMC4wMDM1IDM5LjIwNTVIMjAuMDA3TDQxLjkzMzkgMjguNTYzM0w2NCAzOS40MjIyVjM1LjY0OUw0NS43OTI1IDI2LjY4ODhMNjQgMTcuODUyNFoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-menu-close.svg
// module id = Uxir
// module chunks = 1